import service from './../utils/server'
const modName = '/web/common/qrcode/';

export const getQrCodeDate = data => {
  return service({
    url: modName + 'view/'+data,
    method: 'post',
    responseType: 'blob',
  });
};



// WEBPACK FOOTER //
// ./src/api/qrcodes.js